import { render, staticRenderFns } from "./ListInstitutionPage.vue?vue&type=template&id=46ea8024&"
import script from "./ListInstitutionPage.vue?vue&type=script&lang=js&"
export * from "./ListInstitutionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports